module.exports = __webpack_public_path__ + "static/media/31.5c98f73f.jpg";